var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"centered":"","value":_vm.tab,"color":"blue"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_vm._l((_vm.items),function(rootItem,i){return [_c('v-tab',{key:i,attrs:{"to":rootItem.to}},[_c('span',[_vm._v(_vm._s(rootItem.text))])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }